import React from "react";
import { FeedbackDeal } from "@/components";
import { useModal } from "@/store";
import dealProcessPng from "./images/deal_process.png";
import "./style.less";

function DealBtn(props) {

    const [imageModal] = useModal(["image"]);

    return (
        <div className={`module-dealBtn ${props.className}`}>
            <div className="module-dealBtn__btns flex col ver hor around">
                <FeedbackDeal {...props.feebackProps} className="module-dealBtn__btn-feedback">
                    <button className="module-dealBtn__btn module-dealBtn__btn--yellow">我要交易</button>
                </FeedbackDeal>
                <button className="module-dealBtn__btn module-dealBtn__btn--purple" onClick={imageModal.show.later({ url: dealProcessPng })}>怎么交易</button>
                <button className="module-dealBtn__btn module-dealBtn__btn--blue">我要留言</button>
            </div>
        </div>
    )
}

export default DealBtn;